<template>
    <div>
        <v-btn 
            v-bind="$attrs"
            >
            <v-icon v-if="loading === false" @click="Download">mdi-file-excel-outline</v-icon>
            <v-icon v-else>hourglass_bottom</v-icon>
        </v-btn>
        <app-snackbar 
                :dialog="snackbar.dialog"
                :color="snackbar.color"
                :text="snackbar.text"
                :timeout="snackbar.timeout"
                @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
  export default {
    props: {
    download_modul: String,
    download_type: String,
    download_year: String,
    download_usersid: String
  },
  data: () => ({
    loading: false,
	remarks: {
        dialog: false
    },
    snackbar: {
        dialog: false,
        timeout: 3000,
        text: '',
        color: 'error'
    }
  }),
  methods: {
    Download () {
        this.DownloadFile()
    },
    DownloadFile () {
        this.loading = true
        let formdata = {
            usersbalance_modul: this.download_modul,
            usersbalance_type: this.download_type,
            usersbalance_year: this.download_year,
            usersbalance_usersid: this.download_usersid,
            flag: 'mobileapp',
            order_by: 'users_id',
            order_type: 'ASC',
        }
        let param 	   = this.$functions.ParamPOST(formdata)
        this.$axios.post(this.$functions.UrlPOST('apiUsersBalanceDownload'),param,{
            headers: {
                'Content-Type': 'text/plain; charset=ISO-8859-1'
            }
        })
        .then(response => {
            let feedback = response.data
            if (feedback.length > 0) {
               window.open(feedback[0].usersbalance_download)
            } else {
                this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
            }
            this.loading = false
        })
        .catch(e => {
            this.SnackBar(true, 'error', e, 3000)
            this.loading = false
        })
    },
    SnackBar (dialog, color, text, timeout) {
        this.snackbar = {
            dialog: dialog,
            color: color,
            text: text,
            timeout: timeout
        }
    }
  },
}
</script>